import { useEffect, useState } from "react";
import isEmpty from "lodash.isempty";
import { captureImpressions } from "../../../analytics/cdp/captureImpressions";
import eventBuffer from "../../../analytics/cdp/useCdp";

/**
 * @param {Object[]} safeProductsList
 * @returns {{ onWidgetProductClick: () => void }}
 */
function useWidgetImpressions(safeProductsList) {
  const [isProductClicked, setIsProductClicked] = useState(false);
  const [impressionData, setImpressionData] = useState({});

  useEffect(() => {
    const productElements = document.querySelectorAll("[data-productid]");
    /**
     *
     * @param {*} el
     * @returns
     */
    const getProductData = (el) => {
      const productId = el.getAttribute("data-productid");
      return safeProductsList.find((product) => product.productId === productId);
    };

    captureImpressions({
      productElements: Array.from(productElements),
      getProductData,
      delayTime: 1500,
      allowDuplicates: false,
      onImpressionsReady: (cdpData) => {
        setImpressionData(cdpData);
      },
    });
  }, [safeProductsList]);

  useEffect(() => {
    if (isProductClicked) {
      eventBuffer.track({ event_name: "Product Impression", ...impressionData });
    } else if (!isProductClicked && !isEmpty(impressionData)) {
      const timeoutId = setTimeout(() => {
        eventBuffer.track({ event_name: "Product Impression", ...impressionData });
      }, 15000);
      return () => clearTimeout(timeoutId);
    }
  }, [isProductClicked, impressionData]);

  /**
   * Marks the widget as clicked so pending impressions flush immediately.
   */
  const onWidgetProductClick = () => setIsProductClicked(true);

  return { onWidgetProductClick };
}

export default useWidgetImpressions;
